var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var path = require('path');
var configment = require('@adc/configment');
var InvalidProxyRouteError = (function (_super) {
    __extends(InvalidProxyRouteError, _super);
    function InvalidProxyRouteError(endpoint) {
        var _this = _super.call(this) || this;
        _this.message = "Cannot whitelist " + endpoint + ". See @adc/fetch for more details.";
        return _this;
    }
    return InvalidProxyRouteError;
}(Error));
function hash(str) {
    var hash = 0;
    if (str.length === 0)
        return String(hash);
    for (var i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = hash & hash;
    }
    return hash.toString(36);
}
var defaultProxyOptions = {
    excludeHeaders: ['Cookie'],
    token: 'any',
};
function generateProxyRoute(definition) {
    var basePrefix = configment.get('URL_BASE_PREFIX');
    var endpoint = '';
    var base = {};
    if (typeof definition === 'string') {
        endpoint = definition;
    }
    else {
        endpoint = definition.endpoint;
        base = definition;
    }
    if (!usesProxy(endpoint)) {
        throw new InvalidProxyRouteError(endpoint);
    }
    var url;
    try {
        url = new URL(endpoint);
    }
    catch (e) {
        throw new InvalidProxyRouteError(endpoint);
    }
    var maskedHost = url.host.replace(/(\d{1,3}\.\d{1,3}\.\d{1,3}\.)\d{1,3}(:\d{2,4})/, '$1XXX$2');
    return Object.assign({}, defaultProxyOptions, base, {
        route: path.join(basePrefix, '/cu/api', hash(maskedHost), url.pathname),
        endpoint: endpoint,
    });
}
function usesProxy(route) {
    return !!(route.match(/http:\/\/localhost:\d{2,4}/) ||
        route.match(/http:\/\/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}:\d{2,4}/) ||
        route.match(/http:\/\/.*\.local:\d{4}/) ||
        route.match(/http:\/\/.*\.tenx_overlay:\d{4}/) ||
        route.match(/http:\/\/.*\.ten-x\.cloud(:\d{4})?/) ||
        route.match(/http:\/\/.*\.ten-x\.io:\d{4}/) ||
        route.match(/http:\/\/(.*)\.(.*)\.svc\.cluster\.local(:\d{2,4})?/) ||
        route.match(/http:\/\/(.*)\.(default|backend|app)(:\d{2,4})?/) ||
        route.match(/https:\/\/(service|api)\.(ci|qa|prod|produse2)\.aucn\.io(:\d{2,4})?/));
}
export { generateProxyRoute, usesProxy };
//# sourceMappingURL=proxyRoutes.js.map